import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'Buscar en Google',
    desc: 'Da respuestas genéricas que no distinguen una urgencia real de algo leve.'
  }, {
    title: 'Grupos de Facebook',
    desc: 'Suelen sugerir remedios caseros que terminan intoxicando más al gato.'
  }, {
    title: 'Libros de Veterinaria',
    desc: 'Son imposibles de leer cuando tu corazón está latiendo a mil por hora.'
  }, {
    title: 'Esperar a mañana',
    desc: 'Es el error que más vidas cuesta en las guardias 24hs.'
  }];
  return <section className="py-8 md:py-12 px-4 bg-neutral-950" data-id="element-221">
      <div className="container mx-auto max-w-4xl" data-id="element-222">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-223">
          <h2 className="text-3xl md:text-5xl font-display text-white mb-4" data-id="element-224">
            Lo que ya intentaste{' '}
            <span className="text-neutral-500 line-through" data-id="element-225">no funciona</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-226">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-4 p-6 bg-neutral-900 rounded-xl border border-neutral-800" data-id="element-227">
              <div className="mt-1 bg-red-500/10 p-1 rounded-full text-red-500 shrink-0" data-id="element-228">
                <X size={20} strokeWidth={3} data-id="element-229" />
              </div>
              <div data-id="element-230">
                <h3 className="text-xl font-bold text-white mb-1" data-id="element-231">
                  {item.title}
                </h3>
                <p className="text-neutral-400" data-id="element-232">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}